export default "__VITE_ASSET__DspLMgPB__"